<template>
  <div class="local-only-page">
    <span class="local-only-icon">&#128274;</span>
    <h1>Nur lokal verfügbar</h1>
    <p>
      Dieser Bereich benötigt die Refinitiv-Verbindung bzw. den Control Server
      des lokalen Research-Arbeitsplatzes und ist auf dem Portal-Server nicht
      erreichbar.
    </p>
    <button type="button" class="btn-back" @click="goHome">Zurück zur Startseite</button>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

function goHome() {
  router.push('/admin/reports')
}
</script>

<style scoped>
.local-only-page {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  gap: 8px;
}

.local-only-icon {
  font-size: 40px;
}

.local-only-page h1 {
  font-size: 22px;
  font-weight: 700;
  color: #003366;
  margin-bottom: 4px;
}

.local-only-page p {
  max-width: 420px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.btn-back {
  background: #003366;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
}
.btn-back:hover {
  background: #004080;
}
</style>
